import { IColumn } from 'office-ui-fabric-react';

export const MedicationColumns: IColumn[] = [
    {
        key: 'column1',
        name: 'Id',
        fieldName: 'id',
        minWidth: 110,
        maxWidth: 250,
        isRowHeader: true,
        isResizable: true,
        isSorted: false,
        data: 'string',
        isPadded: true,
    },
    {
        key: 'column2',
        name: 'Medication Text',
        fieldName: 'medicationText',
        minWidth: 210,
        maxWidth: 350,
        isResizable: true,
        isPadded: true,
    },
    {
        key: 'column3',
        name: 'Instructions',
        fieldName: 'dosageInstruction',
        minWidth: 210,
        maxWidth: 350,
        isResizable: true,
        isCollapsible: true,
        data: 'string',
        isPadded: true,
    },
    {
        key: 'column4',
        name: 'Amount',
        fieldName: 'dosageAmount',
        minWidth: 100,
        maxWidth: 100,
        isResizable: true,
        isCollapsible: true,
        data: 'string',
        isPadded: true,
    },
    {
        key: 'column5',
        name: 'Unit',
        fieldName: 'dosageUnit',
        minWidth: 100,
        maxWidth: 100,
        isResizable: true,
        isCollapsible: true,
        data: 'string',
        isPadded: true,
    },
    {
        key: 'column6',
        name: 'Route',
        fieldName: 'dosageRoute',
        minWidth: 100,
        maxWidth: 100,
        isResizable: true,
        isCollapsible: true,
        data: 'string',
        isPadded: true,
    },
    {
        key: 'column7',
        name: 'Medication Id',
        fieldName: 'medicationId',
        minWidth: 100,
        maxWidth: 100,
        isResizable: true,
        isCollapsible: true,
        data: 'string',
        isPadded: true,
    },
    ];
